export default __webpack_public_path__ + "media/images/plot-4-hr-6377989d90e488e4710b43e7246a6bda.png";